import Doughnut from './DoughnutChart';
import Bar from './BarChart';

export const DoughnutChart = Doughnut;
export const BarChart = Bar;
